"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgreementMaintenanceDataT = exports.DEFAULT_AGREEMENT_SIGNING_EMAIL = exports.AGREEMENT_SIGNING_EMAIL_FIELDS = exports.AgreementSigningEmailTemplateT = exports.AgreementMaintenanceAgreementT = exports.AgreementDataT = exports.AgreementCalculatedBudgetT = exports.AgreementOperationalRangeT = exports.isAgreementSigned = exports.ResidentAgreementSummaryT = exports.ResidentAgreementT = exports.getAgreementClientStartDate = exports.isAgreementTemplateEligible = exports.getAgreementEditableFirstPartyFields = exports.getAgreementFirstPartyFields = exports.isAgreementSystemTemplate = exports.AgreementTemplateSummaryT = exports.AgreementTemplateT = exports.AgreementReviewT = exports.MAX_AGREEMENT_SIGNATURES = exports.AgreementSignatureT = exports.AgreementProviderSignatureT = exports.AGREEMENT_PROVIDER_SIGNATURE_AUTHORITY = exports.AgreementSelectedAttachmentSummaryT = exports.AgreementSelectedAttachmentT = exports.AgreementAttachmentSummaryT = exports.AgreementAttachmentT = exports.AgreementCustomValueT = exports.AgreementCustomFieldT = exports.AgreementCustomFieldInputTypeT = exports.hasAgreementStoragePrecision = exports.AgreementFieldDefinitions = exports.AgreementFieldSections = exports.parseAgreementDeedVariationClauses = exports.isAgreementBuiltInField = exports.AgreementDerivedFields = exports.isAgreementFirstPartyField = exports.getAgreementAccommodationCharge = exports.getAgreementDailyAccommodationPayment = exports.AgreementFirstPartyFieldValuesT = exports.AgreementFirstPartyFieldsT = exports.getAgreementSignerAuthorityOptions = exports.AGREEMENT_SIGNER_AUTHORITY_PRIORITY = exports.AgreementCareModeT = exports.AgreementPurposeT = exports.AgreementDocumentSourceT = exports.getAgreementRequirements = exports.AGREEMENT_SYSTEM_TEMPLATE_SHORT_NAMES = exports.isAgreementSchemaReady = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const lodash_1 = __importDefault(require("lodash"));
const dates_1 = require("./dates");
const meta_types_1 = require("./meta-types");
const isAgreementSchemaReady = (version) => version === 11;
exports.isAgreementSchemaReady = isAgreementSchemaReady;
exports.AGREEMENT_SYSTEM_TEMPLATE_SHORT_NAMES = {
    'system:legacy-residential:v1': 'Residential',
    'system:pasa:v1': 'PASA',
    'system:respite:v1': 'Respite',
    'system:home-care:v1': 'Home Care',
    'system:support-at-home:v1': 'Support at Home',
    'system:helf:v1': 'HELF',
    'system:variation:v1': 'Variation letter',
    'system:deed-of-variation:v1': 'Deed of variation',
};
const getAgreementRequirements = (input) => {
    const admissions = lodash_1.default.reject(input.admissions, x => Boolean(x.PreAdmit));
    const latest = lodash_1.default.maxBy(admissions, x => x.StartDate);
    const isRespite = Boolean(latest?.Respite);
    const needsTransition = !input.isHomeCare &&
        !isRespite &&
        lodash_1.default.some(admissions, x => !x.Respite &&
            x.StartDate < '2025-11-01' &&
            (x.EndDate == null || x.EndDate >= '2025-11-01'));
    const hasPASA = lodash_1.default.some(input.agreements, x => x.TemplateKey === 'system:pasa:v1');
    const baseline = () => {
        if (input.isHomeCare) {
            return {
                key: 'home-care',
                label: 'Home Care / Support at Home',
                templateKeys: ['system:home-care:v1', 'system:support-at-home:v1'],
            };
        }
        if (isRespite) {
            return {
                key: 'respite',
                label: 'Respite',
                templateKeys: ['system:respite:v1'],
            };
        }
        return {
            key: 'permanent',
            label: 'Residential / PASA',
            templateKeys: needsTransition && hasPASA
                ? ['system:pasa:v1']
                : ['system:legacy-residential:v1', 'system:pasa:v1'],
        };
    };
    const requirements = [
        baseline(),
        ...(needsTransition && !hasPASA
            ? [
                {
                    key: 'variation',
                    label: 'Variation letter',
                    templateKeys: ['system:variation:v1'],
                },
            ]
            : []),
    ];
    return lodash_1.default.map(requirements, requirement => {
        const agreements = lodash_1.default.filter(input.agreements, x => requirement.templateKeys.includes(x.TemplateKey));
        return {
            ...requirement,
            agreementIDs: lodash_1.default.map(agreements, x => x.ID),
            complete: lodash_1.default.some(agreements, x => x.Locked && x.Signed),
        };
    });
};
exports.getAgreementRequirements = getAgreementRequirements;
exports.AgreementDocumentSourceT = tBox.Union([
    tBox.Literal('markdown'),
    tBox.Literal('external-pdf'),
]);
exports.AgreementPurposeT = tBox.Union([
    tBox.Literal('permanent'),
    tBox.Literal('respite'),
    tBox.Literal('support-at-home'),
    tBox.Literal('helf'),
    tBox.Literal('variation'),
    tBox.Literal('other'),
]);
exports.AgreementCareModeT = tBox.Union([
    tBox.Literal('residential'),
    tBox.Literal('support-at-home'),
    tBox.Literal('any'),
]);
exports.AGREEMENT_SIGNER_AUTHORITY_PRIORITY = [
    { typeIDs: [6, 7, 11], authority: 'POA' },
    { typeIDs: [3, 12], authority: 'Guardian' },
    { typeIDs: [5], authority: 'Financial Manager' },
    { typeIDs: [9], authority: 'Representative' },
    { typeIDs: [2], authority: 'Guarantor' },
    { typeIDs: [4], authority: 'Administrator' },
    { typeIDs: [13], authority: 'Supporter' },
    { typeIDs: [1], authority: 'Emergency Contact' },
    { typeIDs: [8], authority: 'General Practitioner' },
];
const getAgreementSignerAuthorityOptions = (contactTypes) => lodash_1.default.uniq([
    ...lodash_1.default.chain(exports.AGREEMENT_SIGNER_AUTHORITY_PRIORITY)
        .filter(priority => lodash_1.default.some(contactTypes, contactType => lodash_1.default.includes(priority.typeIDs, contactType.ID)))
        .map(priority => priority.authority)
        .value(),
    ...lodash_1.default.chain(contactTypes)
        .reject(contactType => lodash_1.default.some(exports.AGREEMENT_SIGNER_AUTHORITY_PRIORITY, priority => lodash_1.default.includes(priority.typeIDs, contactType.ID)))
        .sortBy('ID')
        .map(contactType => contactType.Name.trim())
        .filter(Boolean)
        .value(),
]);
exports.getAgreementSignerAuthorityOptions = getAgreementSignerAuthorityOptions;
const MaybeStringT = (0, meta_types_1.MaybeT)(tBox.String());
const MaybeShortFieldTextT = (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 1000 }));
const MaybeLongFieldTextT = (0, meta_types_1.MaybeT)(tBox.String({ maxLength: 16_000 }));
const MaybeIntegerT = (0, meta_types_1.MaybeT)(tBox.Integer({ minimum: -2_147_483_648, maximum: 2_147_483_647 }));
const UnsignedIntegerT = tBox.Integer({ minimum: 0, maximum: 4_294_967_295 });
const MaybeUnsignedIntegerT = (0, meta_types_1.MaybeT)(UnsignedIntegerT);
const MaybeMoneyT = (0, meta_types_1.MaybeT)(tBox.Number({ minimum: 0, maximum: 99_999_999_999.99 }));
const MaybePercentageT = (0, meta_types_1.MaybeT)(tBox.Number({ minimum: 0, maximum: 100 }));
const MaybeSignedMoneyT = (0, meta_types_1.MaybeT)(tBox.Number({ minimum: -99_999_999_999.99, maximum: 99_999_999_999.99 }));
const MaybeRateT = (0, meta_types_1.MaybeT)(tBox.Number({ minimum: 0, maximum: 99_999_999.99999 }));
const MaybeBooleanT = (0, meta_types_1.MaybeT)((0, meta_types_1.BooleanInputT)());
const MaybeDateT = (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)());
const additionalServicePeriodOptions = [
    { value: 1, label: 'Term of Agreement' },
    { value: 2, label: 'Part H' },
    { value: 3, label: 'N/A' },
];
const agreementField = (schema, metadata) => ({ schema, ...metadata });
const AGREEMENT_ADMISSION_FIELDS = {
    AdmissionStart: agreementField(MaybeDateT, {
        label: 'Admission Start',
        kind: 'date',
    }),
    AdmissionEnd: agreementField(MaybeDateT, {
        label: 'Discharge Date',
        kind: 'date',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:home-care:v1',
            'system:support-at-home:v1',
            'system:helf:v1',
        ],
    }),
    AdmissionPreStart: agreementField(MaybeDateT, {
        label: 'Pre-Admission Start',
        kind: 'date',
    }),
    AdmissionPreEnd: agreementField(MaybeDateT, {
        label: 'Pre-Admission End',
        kind: 'date',
    }),
    RespiteType: agreementField(MaybeShortFieldTextT, {
        label: 'Respite',
        kind: 'text',
        includedBySystemTemplates: ['system:respite:v1', 'system:helf:v1'],
    }),
    RespiteDays: agreementField(MaybeUnsignedIntegerT, {
        label: 'Approved respite days',
        kind: 'number',
    }),
    ApprovalExpiry: agreementField(MaybeDateT, {
        label: 'Approval Expiry',
        kind: 'date',
    }),
    Location: agreementField(MaybeUnsignedIntegerT, {
        label: 'Location',
        kind: 'number',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
            'system:home-care:v1',
            'system:support-at-home:v1',
        ],
    }),
    BedID: agreementField(MaybeUnsignedIntegerT, {
        label: 'Wing / Room / Bed',
        kind: 'number',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
        ],
    }),
};
const AGREEMENT_ROOM_FIELDS = {
    RoomDescription: agreementField(MaybeShortFieldTextT, {
        label: 'Room description',
        kind: 'text',
    }),
    RoomServices: agreementField(MaybeLongFieldTextT, {
        label: 'Room and services',
        kind: 'long',
    }),
};
const AGREEMENT_CONTACT_FIELDS = {
    AccessApprovalAttached: agreementField(MaybeBooleanT, {
        label: 'Access approval attached',
        kind: 'boolean',
    }),
    CareManagerName: agreementField(MaybeShortFieldTextT, {
        label: 'Care Manager',
        kind: 'text',
    }),
    CareManagerPhone: agreementField(MaybeShortFieldTextT, {
        label: 'Care Manager Ph.',
        kind: 'text',
    }),
};
const AGREEMENT_BASIC_FIELDS = {
    BillingAddress: agreementField(MaybeShortFieldTextT, {
        label: 'Billing address',
        kind: 'text',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
        ],
    }),
};
const AGREEMENT_CONTRIBUTION_FIELDS = {
    BRCType: agreementField(MaybeUnsignedIntegerT, {
        label: 'Basic daily fee type',
        kind: 'number',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
        ],
    }),
    BasicDailyFee: agreementField(MaybeMoneyT, {
        label: 'Basic daily fee amount',
        kind: 'money',
    }),
    HasHCBasicFee: agreementField(MaybeBooleanT, {
        label: 'Charge Home Care basic daily fee',
        kind: 'boolean',
        includedBySystemTemplates: ['system:home-care:v1'],
    }),
    MeansTestAssessed: agreementField(MaybeUnsignedIntegerT, {
        label: 'Means Test Assessed',
        kind: 'number',
        options: [
            { value: 1, label: 'Completed' },
            { value: 2, label: 'Declined' },
            { value: 3, label: 'Pending' },
        ],
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
            'system:home-care:v1',
            'system:support-at-home:v1',
        ],
    }),
    FinancialInfoProvided: agreementField(MaybeBooleanT, {
        label: 'Financial Info Provided',
        kind: 'boolean',
        includedBySystemTemplates: ['system:legacy-residential:v1', 'system:pasa:v1'],
    }),
    MeansTestFee: agreementField(MaybeMoneyT, {
        label: 'Means-Tested Fee',
        kind: 'money',
    }),
    CompPaymentFee: agreementField(MaybeMoneyT, {
        label: 'Compensation Payment',
        kind: 'money',
    }),
    HardshipSupp: agreementField(MaybeMoneyT, {
        label: 'Hardship Supp.',
        kind: 'money',
        includedBySystemTemplates: ['system:home-care:v1', 'system:support-at-home:v1'],
    }),
    RemoteArea: agreementField(MaybeMoneyT, {
        label: 'Remote area',
        kind: 'money',
    }),
    CleanEnergy: agreementField(MaybeBooleanT, {
        label: 'Clean Energy',
        kind: 'boolean',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
            'system:home-care:v1',
            'system:support-at-home:v1',
        ],
    }),
    HotelSuppContr: agreementField(MaybeMoneyT, {
        label: 'Hotelling Contr.',
        kind: 'money',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    NonClinicalContribution: agreementField(MaybeMoneyT, {
        label: 'MTF / NCCC',
        kind: 'money',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    AccommodationCharge: agreementField(MaybeMoneyT, {
        label: 'Accommodation charge',
        kind: 'money',
    }),
};
const AGREEMENT_ACCOMMODATION_FIELDS = {
    AccomFeeType: agreementField(MaybeUnsignedIntegerT, {
        label: 'Accom. Fee Type',
        kind: 'number',
        options: [
            { value: 1, label: 'Accommodation Payment (DAP)' },
            { value: 2, label: 'Accommodation Contribution (DAC)' },
            { value: 3, label: 'N/A (Supported)' },
        ],
        includedBySystemTemplates: ['system:legacy-residential:v1', 'system:pasa:v1'],
    }),
    IsRAC: agreementField(MaybeBooleanT, {
        label: 'RAD / RAC',
        kind: 'boolean',
        includedBySystemTemplates: ['system:legacy-residential:v1', 'system:pasa:v1'],
    }),
    PublishedPrice: agreementField(MaybeMoneyT, {
        label: 'Published Price',
        kind: 'money',
    }),
    AgreedPrice: agreementField(MaybeMoneyT, {
        label: 'Agreed Price',
        kind: 'money',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    AgreedPayment: agreementField(MaybeMoneyT, {
        label: 'Agreed payment',
        kind: 'money',
    }),
    ActualRAD: agreementField(MaybeMoneyT, {
        label: 'Actual RAD',
        kind: 'money',
        includedBySystemTemplates: ['system:legacy-residential:v1', 'system:pasa:v1'],
    }),
    MPIR: agreementField(MaybeRateT, {
        label: 'MPIR',
        kind: 'number',
    }),
    PaymentMethod: agreementField(MaybeUnsignedIntegerT, {
        label: 'Payment Method',
        kind: 'number',
        options: [
            { value: 1, label: 'RAD/RAC only' },
            { value: 2, label: 'DAP/DAC only' },
            { value: 3, label: 'Combination' },
            { value: 4, label: 'N/A (Supported)' },
        ],
        includedBySystemTemplates: ['system:legacy-residential:v1', 'system:pasa:v1'],
    }),
    BookingFeeAccomEntry: agreementField(MaybeMoneyT, {
        label: 'Booking fee',
        kind: 'money',
    }),
};
const AGREEMENT_ADDITIONAL_SERVICE_FIELDS = {
    HasAdditionalServices: agreementField(MaybeBooleanT, {
        label: 'Has Additional Services',
        kind: 'boolean',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    AdditionalServiceFee: agreementField(MaybeMoneyT, {
        label: 'Fee',
        kind: 'money',
        includedBySystemTemplates: ['system:pasa:v1'],
    }),
    AdditionalServiceFeeAdjustment: agreementField(MaybeSignedMoneyT, {
        label: 'Additional service fee adjustment',
        kind: 'money',
    }),
    AdditionalServiceGSTType: agreementField(MaybeIntegerT, {
        label: 'GST Type',
        kind: 'number',
        options: [
            { value: -1, label: 'No GST' },
            { value: 1, label: 'Excludes GST' },
            { value: 2, label: 'Includes GST' },
        ],
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    AdditionalServicePeriodMultiple: agreementField(MaybeUnsignedIntegerT, {
        label: 'Period Multiple',
        kind: 'number',
        options: additionalServicePeriodOptions,
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    AdditionalServicePeriodSingle: agreementField(MaybeUnsignedIntegerT, {
        label: 'Period Single',
        kind: 'number',
        options: additionalServicePeriodOptions,
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    UsePartHNotice: agreementField(MaybeBooleanT, {
        label: 'Use Part H notice',
        kind: 'boolean',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    PriorNoticePeriod: agreementField(MaybeUnsignedIntegerT, {
        label: 'Prior Notice Period',
        kind: 'number',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
    EntryCareFees: agreementField(MaybeMoneyT, {
        label: 'Entry Care Fees',
        kind: 'money',
    }),
    EntryAdditionalServiceFee: agreementField(MaybeMoneyT, {
        label: 'Additional Service Fee',
        kind: 'money',
    }),
    EntryFeePrepaid: agreementField(MaybeMoneyT, {
        label: 'Booking fee pre-paid',
        kind: 'money',
        includedBySystemTemplates: ['system:legacy-residential:v1'],
    }),
};
const AGREEMENT_SUPPORT_AT_HOME_FIELDS = {
    PackageLevel: agreementField(MaybeShortFieldTextT, {
        label: 'Package Level',
        kind: 'text',
        includedBySystemTemplates: ['system:home-care:v1', 'system:support-at-home:v1'],
    }),
    ApprovedPackageLevel1: agreementField(MaybeBooleanT, {
        label: 'Also offer package level 1',
        kind: 'boolean',
    }),
    ApprovedPackageLevel2: agreementField(MaybeBooleanT, {
        label: 'Also offer package level 2',
        kind: 'boolean',
    }),
    ApprovedPackageLevel3: agreementField(MaybeBooleanT, {
        label: 'Also offer package level 3',
        kind: 'boolean',
    }),
    ApprovedPackageLevel4: agreementField(MaybeBooleanT, {
        label: 'Also offer package level 4',
        kind: 'boolean',
    }),
    GovernmentFunding: agreementField(MaybeMoneyT, {
        label: 'Government funding',
        kind: 'money',
    }),
    AdditionalContribution: agreementField(MaybeMoneyT, {
        label: 'Additional contribution',
        kind: 'money',
    }),
    ContributionIndependence: agreementField(MaybePercentageT, {
        label: 'Independence support contribution',
        kind: 'percentage',
    }),
    ContributionEveryday: agreementField(MaybePercentageT, {
        label: 'Everyday support contribution',
        kind: 'percentage',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    DementiaSupp: agreementField(MaybeMoneyT, {
        label: 'Dementia Supp.',
        kind: 'money',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    VeteransSupp: agreementField(MaybeMoneyT, {
        label: 'Veterans Supp.',
        kind: 'money',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    OxygenSupp: agreementField(MaybeMoneyT, {
        label: 'Oxygen Supp.',
        kind: 'money',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    EnteralSupp: agreementField(MaybeMoneyT, {
        label: 'Enteral Supp.',
        kind: 'money',
    }),
    ViabilitySupp: agreementField(MaybeMoneyT, {
        label: 'Viability Supp.',
        kind: 'money',
    }),
    TopUpSupp: agreementField(MaybeMoneyT, {
        label: 'Top-Up Supp.',
        kind: 'money',
    }),
    BudgetedServiceCharges: agreementField(MaybeMoneyT, {
        label: 'Budgeted Services',
        kind: 'money',
    }),
    CareManagementFee: agreementField(MaybeMoneyT, {
        label: 'Care Mgmt. Fee',
        kind: 'money',
    }),
    PackageManagementFee: agreementField(MaybeMoneyT, {
        label: 'Package Mgmt. Fee',
        kind: 'money',
    }),
    CDCTransfer: agreementField(MaybeBooleanT, {
        label: 'Support at Home Transfer',
        kind: 'boolean',
        includedBySystemTemplates: ['system:home-care:v1'],
    }),
    TransferFromOtherProvider: agreementField(MaybeBooleanT, {
        label: 'Transfer from another provider',
        kind: 'boolean',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    TransferFromOtherProviderExitDate: agreementField(MaybeDateT, {
        label: 'Previous provider exit date',
        kind: 'date',
    }),
    PreSeptember2024CareRecipient: agreementField(MaybeBooleanT, {
        label: 'Pre-12 September 2024 care recipient',
        kind: 'boolean',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    ShortTermATHM: agreementField(MaybeBooleanT, {
        label: 'AT-HM services',
        kind: 'boolean',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    ShortTermRestorativeCare: agreementField(MaybeBooleanT, {
        label: 'Restorative care',
        kind: 'boolean',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    ShortTermEndOfLife: agreementField(MaybeBooleanT, {
        label: 'End-of-life care',
        kind: 'boolean',
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    CarePlanAttached: agreementField(MaybeBooleanT, {
        label: 'Care plan attached',
        kind: 'boolean',
        includedBySystemTemplates: ['system:home-care:v1'],
    }),
    PriceIncreaseDate: agreementField(MaybeShortFieldTextT, {
        label: 'Price increase date / notice',
        kind: 'text',
    }),
    SaHPaymentMethod: agreementField(MaybeShortFieldTextT, {
        label: 'Payment Method',
        kind: 'text',
        options: [
            { value: 'DirectDebit', label: 'Direct Debit' },
            { value: 'CentrePay', label: 'CentrePay' },
            { value: 'Other', label: 'Other' },
        ],
        includedBySystemTemplates: ['system:support-at-home:v1'],
    }),
    SaHPaymentMethodDescription: agreementField(MaybeLongFieldTextT, {
        label: 'Description',
        kind: 'long',
    }),
};
const AGREEMENT_CAVEAT_FIELDS = {
    HasCaveatableInterest: agreementField(MaybeBooleanT, {
        label: 'Has Caveatable Interest',
        kind: 'boolean',
        includedBySystemTemplates: [
            'system:legacy-residential:v1',
            'system:pasa:v1',
            'system:respite:v1',
        ],
    }),
    RegisteredProprietor: agreementField(MaybeShortFieldTextT, {
        label: 'Registered Proprietor',
        kind: 'text',
    }),
    CaveatableTitle: agreementField(MaybeShortFieldTextT, {
        label: 'Caveatable Title',
        kind: 'text',
    }),
    RegisteredProprietorGuarantor1: agreementField(MaybeShortFieldTextT, {
        label: 'Guarantor 1 registered proprietor',
        kind: 'text',
    }),
    CaveatableTitleGuarantor1: agreementField(MaybeShortFieldTextT, {
        label: 'Guarantor 1 title reference',
        kind: 'text',
    }),
    RegisteredProprietorGuarantor2: agreementField(MaybeShortFieldTextT, {
        label: 'Guarantor 2 registered proprietor',
        kind: 'text',
    }),
    CaveatableTitleGuarantor2: agreementField(MaybeShortFieldTextT, {
        label: 'Guarantor 2 title reference',
        kind: 'text',
    }),
    CaveatablePropertyAddress: agreementField(MaybeLongFieldTextT, {
        label: 'Caveatable property address',
        kind: 'long',
    }),
    CaveatablePropertyAddressGuarantor1: agreementField(MaybeLongFieldTextT, {
        label: 'Guarantor 1 property address',
        kind: 'long',
    }),
    CaveatablePropertyAddressGuarantor2: agreementField(MaybeLongFieldTextT, {
        label: 'Guarantor 2 property address',
        kind: 'long',
    }),
};
const AGREEMENT_VARIATION_FIELDS = {
    VariedAgreement: agreementField(MaybeUnsignedIntegerT, {
        label: 'Agreement being varied',
        kind: 'number',
        includedBySystemTemplates: ['system:deed-of-variation:v1'],
    }),
    DeedVariationClauses: agreementField(MaybeLongFieldTextT, {
        label: 'Variations',
        kind: 'long',
        includedBySystemTemplates: ['system:deed-of-variation:v1'],
    }),
};
const AGREEMENT_CONDITION_FIELDS = {
    ExtraConditions: agreementField(MaybeLongFieldTextT, {
        label: 'Extra Conditions',
        kind: 'long',
    }),
};
const AGREEMENT_FIELD_CATALOGUE = {
    ...AGREEMENT_ADMISSION_FIELDS,
    ...AGREEMENT_ROOM_FIELDS,
    ...AGREEMENT_CONTACT_FIELDS,
    ...AGREEMENT_BASIC_FIELDS,
    ...AGREEMENT_CONTRIBUTION_FIELDS,
    ...AGREEMENT_ACCOMMODATION_FIELDS,
    ...AGREEMENT_ADDITIONAL_SERVICE_FIELDS,
    ...AGREEMENT_SUPPORT_AT_HOME_FIELDS,
    ...AGREEMENT_CAVEAT_FIELDS,
    ...AGREEMENT_VARIATION_FIELDS,
    ...AGREEMENT_CONDITION_FIELDS,
};
const getAgreementFieldSchemas = (definitions) => lodash_1.default.mapValues(definitions, definition => definition.schema);
exports.AgreementFirstPartyFieldsT = tBox.Object(getAgreementFieldSchemas(AGREEMENT_FIELD_CATALOGUE));
exports.AgreementFirstPartyFieldValuesT = tBox.Partial(exports.AgreementFirstPartyFieldsT);
const getAgreementDailyAccommodationPayment = (fields) => {
    if (fields.AccomFeeType !== 1 || fields.MPIR == null) {
        return null;
    }
    const rad = fields.AgreedPrice ?? fields.ActualRAD;
    if (rad == null) {
        return null;
    }
    const daily = (rad - (fields.AgreedPayment ?? 0)) * (fields.MPIR / 100 / 365);
    const scaled = Number((daily * 100).toFixed(10));
    return Math.max(0, Math.floor(scaled) / 100);
};
exports.getAgreementDailyAccommodationPayment = getAgreementDailyAccommodationPayment;
const getAgreementAccommodationCharge = (fields, deriveDailyPayment = true) => {
    if (fields.AccomFeeType === 3 ||
        fields.PaymentMethod === 1 ||
        fields.PaymentMethod === 4) {
        return null;
    }
    return deriveDailyPayment && fields.AccomFeeType === 1
        ? (0, exports.getAgreementDailyAccommodationPayment)(fields)
        : (fields.AccommodationCharge ?? null);
};
exports.getAgreementAccommodationCharge = getAgreementAccommodationCharge;
const isAgreementFirstPartyField = (field) => Object.prototype.hasOwnProperty.call(exports.AgreementFirstPartyFieldsT.properties, field);
exports.isAgreementFirstPartyField = isAgreementFirstPartyField;
exports.AgreementDerivedFields = [
    'ABN',
    'AdditionalServiceTypeGST',
    'AgreementDate',
    'AuthorisedRepresentativesRows',
    'DailyCont',
    'DailyTotalSup',
    'DAPDAC1',
    'DAPDAC2',
    'DeedVariationClauseRows',
    'ECAddress',
    'ECDrivers',
    'ECEmail',
    'ECName',
    'ECPhone',
    'EntryAccommodationCost',
    'EntryTotal',
    'FacilityAddress',
    'FacilityName',
    'GPAddress',
    'GPDrivers',
    'GPEmail',
    'GPName',
    'GPPhone',
    'Guarantor2Address',
    'Guarantor2Drivers',
    'Guarantor2Email',
    'Guarantor2Name',
    'Guarantor2Phone',
    'GuarantorAddress',
    'GuarantorDrivers',
    'GuarantorEmail',
    'GuarantorName',
    'GuarantorPhone',
    'HC10A',
    'HC10B',
    'HC1A',
    'HC1B',
    'HC1C',
    'HC1D',
    'HC2A',
    'HC2B',
    'HC3A',
    'HC3B',
    'HC3C',
    'HC3D',
    'HC3E',
    'HC3F',
    'HC3G',
    'HC4A',
    'HC4B',
    'HC6A',
    'HC6B',
    'HC7A',
    'HC7B',
    'HeaderImage',
    'HELFTable',
    'MeansNotDisclosedNo',
    'MeansNotDisclosedYes',
    'P01A',
    'P01B',
    'P02A',
    'P02B',
    'P02C',
    'P03A',
    'P03B',
    'P03C',
    'P04A',
    'P04B',
    'P04C',
    'P05A',
    'P05B',
    'P05C',
    'P06A',
    'P06B',
    'P06C',
    'P07A',
    'P07B',
    'P08A',
    'P09A',
    'P10A',
    'P10B',
    'P11A',
    'P11B',
    'PaymentCycle',
    'PaymentMethodCentrepay',
    'PaymentMethodDirectDebit',
    'PaymentMethodOther',
    'ProviderAddress',
    'ProviderContactDetails',
    'ProviderName',
    'RADRAC1',
    'RADRAC2',
    'RADRACDIFF',
    'Relationship',
    'ResidentAddress',
    'ResidentBillingAddress',
    'ResidentDoB',
    'ResidentEmail',
    'ResidentFullName',
    'ResidentPhone',
    'RespiteStatus',
    'ReviewDate',
    'Room',
    'SIGNATURE_PAGE',
    'SH1A',
    'SH1B',
    'SH1C',
    'SH1D',
    'SH2A',
    'SH2B',
    'SH2C',
    'SH3A',
    'SH3B',
    'SH3C',
    'SH4A',
    'SH4B',
    'SupportAtHomeBudget',
    'SupporterRows',
    'TotalCareFees',
    'TotalDailyAmount',
    'TotalDailyExpenditure',
    'TotalDailyPackFunds',
    'TotalResidentContribution',
    'TransferFromOtherProviderNo',
    'TransferFromOtherProviderYes',
    'VariationDate',
    'VariedAgreementDate',
];
const isAgreementBuiltInField = (field) => (0, exports.isAgreementFirstPartyField)(field) || lodash_1.default.includes(exports.AgreementDerivedFields, field);
exports.isAgreementBuiltInField = isAgreementBuiltInField;
const parseAgreementDeedVariationClauses = (value) => {
    try {
        const parsed = JSON.parse(value ?? '[]');
        return lodash_1.default.isArray(parsed) && lodash_1.default.every(parsed, item => lodash_1.default.isString(item))
            ? parsed
            : null;
    }
    catch {
        return null;
    }
};
exports.parseAgreementDeedVariationClauses = parseAgreementDeedVariationClauses;
const AGREEMENT_FIELD_SECTION_CATALOGUE = [
    {
        key: 'admission',
        title: 'Admission',
        labelWidth: 156,
        definitions: AGREEMENT_ADMISSION_FIELDS,
    },
    {
        key: 'basic',
        title: 'Basic',
        labelWidth: 156,
        definitions: AGREEMENT_BASIC_FIELDS,
    },
    {
        key: 'contacts',
        title: 'Contacts',
        labelWidth: 156,
        definitions: AGREEMENT_CONTACT_FIELDS,
    },
    {
        key: 'room-services',
        title: 'Room Services',
        labelWidth: 156,
        definitions: AGREEMENT_ROOM_FIELDS,
    },
    {
        key: 'contributions',
        title: 'Fees and Finance',
        labelWidth: 156,
        definitions: AGREEMENT_CONTRIBUTION_FIELDS,
    },
    {
        key: 'accommodation',
        title: 'RAD',
        labelWidth: 156,
        definitions: AGREEMENT_ACCOMMODATION_FIELDS,
    },
    {
        key: 'additional-services',
        title: 'Additional Services',
        labelWidth: 156,
        definitions: AGREEMENT_ADDITIONAL_SERVICE_FIELDS,
    },
    {
        key: 'support-at-home',
        title: 'Support at Home',
        labelWidth: 156,
        definitions: AGREEMENT_SUPPORT_AT_HOME_FIELDS,
    },
    {
        key: 'caveat',
        title: 'Caveatable Interest',
        labelWidth: 156,
        definitions: AGREEMENT_CAVEAT_FIELDS,
    },
    {
        key: 'deed-variation',
        title: 'Deed of Variation',
        labelWidth: 156,
        definitions: AGREEMENT_VARIATION_FIELDS,
    },
    {
        key: 'conditions',
        title: 'Extra Conditions',
        labelWidth: 156,
        definitions: AGREEMENT_CONDITION_FIELDS,
    },
];
exports.AgreementFieldSections = lodash_1.default.map(AGREEMENT_FIELD_SECTION_CATALOGUE, section => ({
    key: section.key,
    title: section.title,
    labelWidth: section.labelWidth,
    fields: lodash_1.default.filter(Object.keys(section.definitions), exports.isAgreementFirstPartyField),
}));
exports.AgreementFieldDefinitions = lodash_1.default.flatMap(Object.entries(AGREEMENT_FIELD_CATALOGUE), ([field, definition]) => {
    if (!(0, exports.isAgreementFirstPartyField)(field)) {
        return [];
    }
    const section = lodash_1.default.find(exports.AgreementFieldSections, candidate => candidate.fields.includes(field));
    if (!section) {
        return [];
    }
    return [
        {
            field,
            label: definition.label,
            kind: definition.kind,
            options: definition.options,
            section: section.key,
            includedBySystemTemplates: definition.includedBySystemTemplates,
        },
    ];
});
const hasAgreementDecimalPlaces = (value, places) => Number(value.toFixed(places)) === value;
const hasAgreementStoragePrecision = (fields) => lodash_1.default.every(exports.AgreementFieldDefinitions, definition => {
    const value = fields[definition.field];
    if (typeof value !== 'number') {
        return true;
    }
    if (definition.field === 'MPIR') {
        return hasAgreementDecimalPlaces(value, 5);
    }
    return (!lodash_1.default.includes(['money', 'percentage'], definition.kind) ||
        hasAgreementDecimalPlaces(value, 2));
});
exports.hasAgreementStoragePrecision = hasAgreementStoragePrecision;
exports.AgreementCustomFieldInputTypeT = tBox.Union([
    tBox.Literal('single-line'),
    tBox.Literal('multi-line'),
]);
exports.AgreementCustomFieldT = tBox.Object({
    ID: tBox.Number(),
    Code: tBox.String({ maxLength: 80 }),
    Name: tBox.String({ maxLength: 255 }),
    InputType: exports.AgreementCustomFieldInputTypeT,
    DefaultMarkdown: tBox.String({ maxLength: 100_000 }),
});
exports.AgreementCustomValueT = tBox.Object({
    Field: UnsignedIntegerT,
    Code: tBox.String({ maxLength: 80 }),
    ValueMarkdown: tBox.String({ maxLength: 100_000 }),
});
exports.AgreementAttachmentT = tBox.Object({
    ID: tBox.Number(),
    Name: tBox.String({ maxLength: 255 }),
    Checksum: MaybeStringT,
    DefaultSelected: (0, meta_types_1.BooleanInputT)(),
    CoverPage: (0, meta_types_1.BooleanInputT)(),
    Enabled: (0, meta_types_1.BooleanInputT)(),
});
exports.AgreementAttachmentSummaryT = tBox.Pick(exports.AgreementAttachmentT, [
    'ID',
    'Name',
    'DefaultSelected',
    'Enabled',
]);
exports.AgreementSelectedAttachmentT = tBox.Object({
    Attachment: tBox.Number(),
    Name: tBox.String({ maxLength: 255 }),
    Checksum: MaybeStringT,
    CoverPage: (0, meta_types_1.BooleanInputT)(),
});
exports.AgreementSelectedAttachmentSummaryT = tBox.Pick(exports.AgreementSelectedAttachmentT, ['Attachment', 'Name']);
exports.AGREEMENT_PROVIDER_SIGNATURE_AUTHORITY = 'Provider Representative';
exports.AgreementProviderSignatureT = tBox.Object({
    SignerName: tBox.String({ maxLength: 255 }),
    Authority: tBox.Literal(exports.AGREEMENT_PROVIDER_SIGNATURE_AUTHORITY),
    SignedAt: (0, dates_1.DateTimeObjT)(),
});
exports.AgreementSignatureT = tBox.Object({
    ID: tBox.Number(),
    ResidentContact: (0, meta_types_1.MaybeT)(tBox.Number()),
    Method: tBox.Union([
        tBox.Literal('online'),
        tBox.Literal('in-person'),
        tBox.Literal('manual'),
    ]),
    SignerName: tBox.String({ maxLength: 255 }),
    Authority: tBox.String({ maxLength: 255 }),
    Email: MaybeStringT,
    RequestedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    SignedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    SignedDateKnown: tBox.Boolean(),
    SignatureChecksum: MaybeStringT,
    ProofChecksum: MaybeStringT,
    CancelledAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
});
exports.MAX_AGREEMENT_SIGNATURES = 21;
exports.AgreementReviewT = tBox.Object({
    ReviewDate: (0, dates_1.DateObjT)(),
    Comment: tBox.String({ maxLength: 4000 }),
});
exports.AgreementTemplateT = tBox.Object({
    Key: tBox.String({ maxLength: 80 }),
    Title: tBox.String({ maxLength: 255 }),
    Purpose: exports.AgreementPurposeT,
    CareMode: exports.AgreementCareModeT,
    Markdown: tBox.String({ maxLength: 1_000_000 }),
    Enabled: tBox.Boolean(),
    AvailableFrom: MaybeStringT,
    AvailableTo: MaybeStringT,
    Fields: tBox.Array(tBox.String()),
});
exports.AgreementTemplateSummaryT = tBox.Omit(exports.AgreementTemplateT, ['Markdown']);
const isAgreementSystemTemplate = (template) => template.Key.startsWith('system:');
exports.isAgreementSystemTemplate = isAgreementSystemTemplate;
const getAgreementFirstPartyFields = (template) => lodash_1.default.chain([
    ...lodash_1.default.filter(template.Fields, exports.isAgreementFirstPartyField),
    ...(template.Fields.includes('SupportAtHomeBudget') ? ['Location'] : []),
    ...lodash_1.default.chain(exports.AgreementFieldDefinitions)
        .filter(definition => Boolean(definition.includedBySystemTemplates?.includes(template.Key)))
        .map(definition => definition.field)
        .value(),
])
    .uniq()
    .value();
exports.getAgreementFirstPartyFields = getAgreementFirstPartyFields;
const getAgreementEditableFirstPartyFields = (template) => lodash_1.default.reject((0, exports.getAgreementFirstPartyFields)(template), field => (0, exports.isAgreementSystemTemplate)(template) &&
    (field === 'BasicDailyFee' ||
        (field === 'RespiteType' && template.Key === 'system:respite:v1')));
exports.getAgreementEditableFirstPartyFields = getAgreementEditableFirstPartyFields;
const isAgreementTemplateEligible = (template, careMode, agreementDate, clientStartDate) => {
    if (!template.Enabled ||
        (template.CareMode !== 'any' && template.CareMode !== careMode)) {
        return false;
    }
    const date = template.Purpose === 'permanent' ? clientStartDate : agreementDate;
    return ((template.AvailableFrom == null || date >= template.AvailableFrom) &&
        (template.AvailableTo == null || date <= template.AvailableTo));
};
exports.isAgreementTemplateEligible = isAgreementTemplateEligible;
const getAgreementClientStartDate = (agreementDate, dates) => lodash_1.default.chain([agreementDate, ...dates])
    .filter((date) => date != null)
    .sortBy(date => date.u)
    .first()
    .value() ?? agreementDate;
exports.getAgreementClientStartDate = getAgreementClientStartDate;
exports.ResidentAgreementT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    TemplateKey: tBox.String(),
    Title: tBox.String(),
    DocumentSource: exports.AgreementDocumentSourceT,
    AgreementDate: (0, dates_1.DateObjT)(),
    InternalComment: tBox.String(),
    SigningEmailTemplate: MaybeUnsignedIntegerT,
    SelectedBudget: MaybeUnsignedIntegerT,
    ExternalFileChecksum: MaybeStringT,
    SnapshotMarkdown: MaybeStringT,
    LockedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    LockedBy: (0, meta_types_1.MaybeT)(tBox.Number()),
    ProviderSignature: (0, meta_types_1.MaybeT)(exports.AgreementProviderSignatureT),
    DeletedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    Revision: tBox.Number(),
    Fields: exports.AgreementFirstPartyFieldsT,
    CustomValues: tBox.Array(exports.AgreementCustomValueT),
    HELFFees: tBox.Array(UnsignedIntegerT),
    Attachments: tBox.Array(exports.AgreementSelectedAttachmentT),
    Signatures: tBox.Array(exports.AgreementSignatureT),
    Reviews: tBox.Array(exports.AgreementReviewT),
});
exports.ResidentAgreementSummaryT = tBox.Composite([
    tBox.Omit(exports.ResidentAgreementT, ['Attachments']),
    tBox.Object({
        Attachments: tBox.Array(exports.AgreementSelectedAttachmentSummaryT),
        HasPDFAppendix: tBox.Boolean(),
    }),
]);
const isAgreementSigned = (signatures) => {
    const active = lodash_1.default.filter(signatures, signature => !signature.CancelledAt);
    return active.length > 0 && lodash_1.default.every(active, signature => signature.SignedAt != null);
};
exports.isAgreementSigned = isAgreementSigned;
exports.AgreementOperationalRangeT = tBox.Object({
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Label: tBox.String(),
});
exports.AgreementCalculatedBudgetT = tBox.Object({
    StartDate: (0, dates_1.DateObjT)(),
    EndDate: (0, meta_types_1.MaybeT)((0, dates_1.DateObjT)()),
    Days: tBox.Number(),
    Package: tBox.String(),
    DailyServiceCost: tBox.Number(),
    Fees: tBox.Array(tBox.Object({
        Name: tBox.String(),
        Category: tBox.Union([
            tBox.Literal('funding'),
            tBox.Literal('fee'),
            tBox.Literal('other'),
        ]),
        Units: tBox.Number(),
        Amount: tBox.Number(),
    })),
    Services: tBox.Array(tBox.Object({
        Name: tBox.String(),
        Day: tBox.Number(),
        Start: tBox.String(),
        Stop: tBox.String(),
        Units: tBox.Number(),
        BudgetAmount: tBox.Number(),
        ClientContribution: tBox.Number(),
        Error: MaybeStringT,
    })),
});
exports.AgreementDataT = tBox.Object({
    Agreements: tBox.Array(exports.ResidentAgreementSummaryT),
    Templates: tBox.Array(exports.AgreementTemplateSummaryT),
    CustomFields: tBox.Array(exports.AgreementCustomFieldT),
    Attachments: tBox.Array(exports.AgreementAttachmentSummaryT),
    OperationalRanges: tBox.Array(exports.AgreementOperationalRangeT),
    SigningEmailTemplates: tBox.Array(tBox.Object({ ID: UnsignedIntegerT, Name: tBox.String() })),
});
exports.AgreementMaintenanceAgreementT = tBox.Object({
    ID: tBox.Number(),
    Resident: tBox.Number(),
    TemplateKey: tBox.String(),
    DocumentSource: exports.AgreementDocumentSourceT,
    Revision: tBox.Number(),
    Title: tBox.String(),
    AgreementDate: (0, dates_1.DateObjT)(),
    StartDate: (0, dates_1.DateObjT)(),
    LockedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    DeletedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
    ActiveSignatures: tBox.Array(tBox.Object({
        ID: tBox.Number(),
        SignerName: tBox.String(),
        Email: MaybeStringT,
        RequestedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
        SignedAt: (0, meta_types_1.MaybeT)((0, dates_1.DateTimeObjT)()),
        SignedDateKnown: tBox.Boolean(),
    })),
});
exports.AgreementSigningEmailTemplateT = tBox.Object({
    ID: UnsignedIntegerT,
    Name: tBox.String({ minLength: 1, maxLength: 255 }),
    Subject: tBox.String({ minLength: 1, maxLength: 255 }),
    Text: tBox.String({ minLength: 1, maxLength: 100_000 }),
});
exports.AGREEMENT_SIGNING_EMAIL_FIELDS = [
    'ResidentFirstName',
    'ResidentFullName',
    'FacilityName',
    'AgreementType',
    'RequestLink',
    'SignerName',
];
exports.DEFAULT_AGREEMENT_SIGNING_EMAIL = {
    Subject: 'Signature requested for {ResidentFullName}: {AgreementType}',
    Text: 'Hello {SignerName},\n\nPlease review and sign {AgreementType} for {ResidentFullName}.\n{RequestLink}',
};
exports.AgreementMaintenanceDataT = tBox.Object({
    Agreements: tBox.Array(exports.AgreementMaintenanceAgreementT),
    Templates: tBox.Array(exports.AgreementTemplateT),
    CustomFields: tBox.Array(exports.AgreementCustomFieldT),
    Attachments: tBox.Array(exports.AgreementAttachmentT),
    SigningEmailTemplates: tBox.Array(exports.AgreementSigningEmailTemplateT),
});
//# sourceMappingURL=types-billing-agreements.js.map